(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
/* P3.E: Zubehör/Cargo-Add + Master-Cargo-Checkout-Wächter (Drawer wird nach Add per cart:refresh neu gerendert) */
document.addEventListener('click', function (e) {
  var add = e.target.closest('[data-cargo-add]');
  if (!add) return;
  e.preventDefault();
  add.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-cargo-add'), 10), quantity: 1 }] })
  }).then(function () {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  });
});
/* Umbau 1: „Dazu passt“ – Artikel per AJAX dazulegen, Drawer neu rendern. Das Oberflächen-Häkchen betrifft nur die Handpan und wird hier weder ausgelöst noch umgangen. */
document.addEventListener('click', function (e) {
  var add = e.target.closest('[data-hpl-dazu]');
  if (!add) return;
  e.preventDefault();
  add.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-hpl-dazu'), 10), quantity: 1, properties: { _quelle: 'dazu-passt-drawer' } }] })
  }).then(function (r) {
    if (!r.ok) { add.disabled = false; return; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }).catch(function () { add.disabled = false; });
});
/* STILLGELEGT 31.07.2026: Der Checkout-Waechter gehoerte zur Cargo-Pflicht-Wache.
   Ohne die Wache im Markup laeuft er ins Leere. Wieder aktivieren, sobald der HCT Cargo
   lieferbar ist und die Pflicht-Zuwahl zurueckkommt (Stand im Git, Nachtraege 38/45). */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.closest || !form.closest('#cart-drawer')) return;
  var wache = document.querySelector('[data-hpl-cargo-wache]');
  if (!wache) return;
  var abholung = wache.querySelector('[data-cargo-abholung]');
  if (!abholung) return;
  if (abholung.checked) {
    if (window.hplTrack) window.hplTrack('master_cargo_choice', { choice: 'abholung', source_module: 'cart' });
    return;
  }
  e.preventDefault();
  wache.scrollIntoView({ block: 'center' });
  wache.style.outline = '2px solid #E0A33C';
  setTimeout(function () { wache.style.outline = ''; }, 1600);
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-miete-warteliste"] && !Shopify.designMode) return;
  try {
    
(function () {
  var forms = document.querySelectorAll('.hpl-mw-form');
  forms.forEach(function (form) {
    if (form.dataset.bound) { return; }
    form.dataset.bound = '1';

    var pk = form.dataset.pk;
    var list = form.dataset.list;
    var source = form.dataset.source || 'Mietseite';
    var msg = form.querySelector('.hpl-mw-msg');
    var btn = form.querySelector('.hpl-mw-btn');
    var emailEl = form.querySelector('input[type="email"]');
    var modellEl = form.querySelector('select[name="modell"]');
    var consentEl = form.querySelector('.hpl-mw-check');
    var newsEl = form.querySelector('.hpl-mw-news');
    var newsList = form.dataset.newsList;
    var btnLabel = btn ? btn.textContent : 'Benachrichtige mich';

    function subscribe(listId, props, src) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pk), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: src,
              profile: { data: { type: 'profile', attributes: { email: emailEl.value.trim(), properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl && emailEl.value ? emailEl.value : '').trim();
      var modell = modellEl ? modellEl.value : '';
      var consent = consentEl ? consentEl.checked : false;

      msg.className = 'hpl-mw-msg';
      if (!email || email.indexOf('@') === -1) {
        msg.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
        msg.classList.add('is-error');
        return;
      }
      if (!consent) {
        msg.textContent = 'Bitte bestätige, dass wir dich benachrichtigen dürfen.';
        msg.classList.add('is-error');
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Einen Moment …';

      var wantsNews = !!(newsEl && newsEl.checked && newsList);

      subscribe(list, {
        'Miet-Interesse': modell || 'Noch unentschieden',
        'Quelle': source
      }, source).then(function (res) {
        if (res.ok || res.status === 202) {
          // Newsletter ist eine eigene Einwilligung -> eigener Aufruf auf die Newsletter-Liste.
          // Schlaegt er fehl, bleibt die Warteliste trotzdem bestaetigt.
          if (wantsNews) {
            subscribe(newsList, { 'Quelle': source + ' (Newsletter-Opt-in)' }, source + ' – Newsletter')
              .then(function (r) {
                if ((r.ok || r.status === 202) && window.dataLayer) {
                  window.dataLayer.push({ event: 'newsletter_optin', source: 'miete-warteliste' });
                }
              })
              .catch(function () { /* Warteliste ist gesichert; Newsletter still verworfen */ });
          }
          form.innerHTML = '<p class="hpl-mw-erfolg"><strong>Fast geschafft.</strong> Wir haben dir eine E-Mail geschickt – bitte bestätige darin kurz deine Adresse. Danach melden wir uns, sobald es losgeht.</p>';
          if (window.dataLayer) {
            window.dataLayer.push({ event: 'miete_warteliste_signup', modell: modell || 'unentschieden', newsletter: wantsNews });
          }
        } else {
          throw new Error('status ' + res.status);
        }
      }).catch(function () {
        msg.textContent = 'Das hat gerade nicht geklappt. Schreib uns einfach an kontakt@handpanladen.de, dann tragen wir dich von Hand ein.';
        msg.classList.add('is-error');
        btn.disabled = false;
        btn.textContent = btnLabel;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-pdp-signature"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.hpl-sig-main');
  if(!root) return;

  // ===== Galerie-Karussell =====
  // Gewischt wird nativ ueber scroll-snap. Das JS macht nur drei Dinge:
  // ablesen, welches Bild gerade steht (Punkte/Vorschau/Badge nachziehen),
  // auf Klick dorthin scrollen, und bei Variantenwechsel das passende Bild anfahren.
  var track = root.querySelector('#sigTrack');
  var galBadge = root.querySelector('#sigGalBadge');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.sig-slide')) : [];
  var dots = root.querySelectorAll('.sig-dot');
  var thumbs = root.querySelectorAll('.sig-thumbs img');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var aktuell = 0;

  function setBadge(label){
    if(!galBadge) return;
    if(label){ galBadge.textContent = label; galBadge.hidden = false; }
    else { galBadge.hidden = true; }
  }
  function markiere(i){
    if(i === aktuell) return;
    aktuell = i;
    for(var d = 0; d < dots.length; d++){ dots[d].classList.toggle('is-on', d === i); }
    for(var t = 0; t < thumbs.length; t++){ thumbs[t].classList.toggle('is-on', t === i); }
    setBadge(slides[i] ? (slides[i].dataset.label || '') : '');
  }
  function geheZu(i, sanft){
    if(!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    var ziel = i * track.clientWidth;
    var vorher = track.scrollLeft;
    try { track.scrollTo({ left: ziel, behavior: (sanft && !reduceMotion) ? 'smooth' : 'auto' }); }
    catch(e){ track.scrollLeft = ziel; }
    // Sicherheitsnetz: Wo scrollTo nichts bewirkt (aeltere Engines, scroll-snap-Konflikte),
    // stuenden die Punkte auf Bild 3 und das Bild auf 1 - Vorschau und Pfeile wirkten tot.
    // Nur eingreifen, wenn sich NICHTS bewegt hat; ein laufender oder vom Nutzer
    // uebernommener Scroll wird dadurch nie unterbrochen.
    if(Math.abs(ziel - vorher) > 2){
      window.setTimeout(function(){
        if(track.scrollLeft === vorher) track.scrollLeft = ziel;
      }, 400);
    }
    markiere(i);
  }

  if(track && slides.length){
    setBadge(slides[0].dataset.label || '');
    // Bewusst OHNE requestAnimationFrame-Drossel: Die uebliche ticking-Sperre bleibt
    // haengen, wenn rAF pausiert (Tab im Hintergrund) - danach aktualisiert nichts mehr.
    // markiere() steigt bei unveraendertem Index sofort aus, die Rechnung ist also
    // eine Division pro Scroll-Event. Das ist billiger als die Sperre.
    track.addEventListener('scroll', function(){
      var b = track.clientWidth;
      if(b) markiere(Math.round(track.scrollLeft / b));
    }, { passive: true });

    for(var t2 = 0; t2 < thumbs.length; t2++){
      (function(el){
        el.addEventListener('click', function(){ geheZu(parseInt(el.dataset.idx, 10) || 0, true); });
      })(thumbs[t2]);
    }
    var prev = root.querySelector('.sig-gal-prev'), next = root.querySelector('.sig-gal-next');
    if(prev) prev.addEventListener('click', function(){ geheZu(aktuell - 1, true); });
    if(next) next.addEventListener('click', function(){ geheZu(aktuell + 1, true); });
    track.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); geheZu(aktuell + 1, true); }
      else if(e.key === 'ArrowLeft'){ e.preventDefault(); geheZu(aktuell - 1, true); }
    });
    // Breitenwechsel (Drehen des Geraets): Position neu setzen, sonst steht die Schiene schief
    window.addEventListener('resize', function(){
      var i = aktuell;
      window.requestAnimationFrame(function(){ if(track.clientWidth) track.scrollLeft = i * track.clientWidth; });
    });
  }

  // Kaufbox-Audio-Player (kurze Hörprobe)
  var au = root.querySelector('#sigAu');
  if(au){
    var pb = root.querySelector('#sigPb'), pico = root.querySelector('#sigPico'),
        fill = root.querySelector('#sigFill'), bar = root.querySelector('#sigBar');
    var PLAY = '<path d="M8 5.5v13l11-6.5z"/>', PAUSE = '<path d="M7.5 5h3.2v14H7.5zM13.3 5h3.2v14h-3.2z"/>';
    if(pb) pb.addEventListener('click', function(){ if(au.paused){ au.play(); if(pico) pico.innerHTML = PAUSE; } else { au.pause(); if(pico) pico.innerHTML = PLAY; } });
    au.addEventListener('timeupdate', function(){ if(au.duration && fill) fill.style.width = (au.currentTime/au.duration*100)+'%'; });
    au.addEventListener('ended', function(){ if(pico) pico.innerHTML = PLAY; if(fill) fill.style.width = '0%'; });
    if(bar) bar.addEventListener('click', function(e){ if(!au.duration) return; var r = bar.getBoundingClientRect(); au.currentTime = (e.clientX-r.left)/r.width*au.duration; });
    root.querySelectorAll('.sig-ptab').forEach(function(tab){
      tab.addEventListener('click', function(){
        root.querySelectorAll('.sig-ptab').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        tab.setAttribute('aria-pressed','true');
        var was = !au.paused; au.pause(); au.src = tab.dataset.src; if(fill) fill.style.width = '0%';
        if(was){ au.play(); if(pico) pico.innerHTML = PAUSE; } else if(pico){ pico.innerHTML = PLAY; }
      });
    });
  }

  // Varianten-Auswahl über Chips
  var data = window.HPL_SIG;
  var T = (data && data.t) || {};
  var idInput = root.querySelector('#sigVid');
  // Mehrzahl seit der Anzahlungs-Kapsel: der volle Preis steht im Kopf UND im Hinweis.
  var priceEls = root.querySelectorAll('[data-sig-price]');
  // Mehrzahl: der halbe Betrag steht im Auswahl-Label UND im Hinweis darunter.
  var depEls = root.querySelectorAll('[data-sig-dep]');
  var atc = root.querySelector('[data-sig-atc]');
  var selected = {};
  root.querySelectorAll('.sig-chip[data-opt]').forEach(function(c){
    if(c.getAttribute('aria-pressed') === 'true') selected[c.dataset.opt] = c.dataset.value;
  });
  // Optionen ohne sichtbare Auswahl (nur_stimmung): fester Wert, damit currentVariant() trifft
  root.querySelectorAll('.sig-opt-fix[data-opt]').forEach(function(f){
    selected[f.dataset.opt] = f.dataset.value;
  });
  function currentVariant(){
    if(!data || !data.variants) return null;
    var keys = Object.keys(selected).sort(function(a,b){ return a - b; });
    var vals = keys.map(function(k){ return selected[k]; });
    return data.variants.filter(function(v){
      return v.options.length === vals.length && v.options.every(function(o,i){ return o === vals[i]; });
    })[0];
  }
  function update(){
    var v = currentVariant();
    if(!v) return;
    if(idInput) idInput.value = v.id;
    // Pilot Versand-ab: Zeile der gewaehlten Variante zeigen, Property nur dann mitsenden
    var vabTxt = '';
    root.querySelectorAll('[data-sig-vab]').forEach(function(el){
      var an = String(el.dataset.variantId) === String(v.id);
      el.hidden = !an;
      if(an) vabTxt = el.dataset.vab || '';
    });
    // aufbau_kompakt: keine Versand-ab-Zeilen im HTML, der Termin kommt aus HPL_SIG
    if(typeof v.vab === 'string' && !root.querySelector('[data-sig-vab]')) vabTxt = v.vab;
    var vabInput = root.querySelector('#sigVab');
    if(vabInput){ vabInput.value = vabTxt; vabInput.disabled = !vabTxt; }
    priceEls.forEach(function(el){ el.textContent = v.price; });
    depEls.forEach(function(el){ el.textContent = v.half; });
    // Oberflaechen-Wahl faehrt das passende Bild im Karussell an (statt es zu tauschen)
    if(v.imgid && slides.length){
      for(var si = 0; si < slides.length; si++){
        if(String(slides[si].dataset.imgid) === String(v.imgid)){ geheZu(si, true); break; }
      }
    }
    var lbl = root.querySelector('[data-sig-atc-label]');
    if(atc){
      atc.disabled = !v.available;
      if(lbl){
        var vorbestellung = v.tracked && v.policy === 'continue' && v.qty <= 0;
        lbl.textContent = !v.available ? T.nv
          : (v.qty > 0 ? (atc.dataset.labelStock || T.warenkorb)
          : (vorbestellung ? (atc.dataset.labelVor || T.vorbestellen)
          : (atc.dataset.label || T.fertigen)));
      }
    }
    // Lieferhinweis unter dem Knopf zieht mit derselben Unterscheidung mit
    var lh = root.querySelector('[data-sig-lh]');
    if(lh){
      var lhVorbestellung = v.tracked && v.policy === 'continue' && v.qty <= 0;
      var lhTxt = '';
      if(v.available) lhTxt = v.qty > 0 ? (lh.dataset.lhLager || '') : (lhVorbestellung ? (lh.dataset.lhVor || '') : '');
      lh.textContent = lhTxt;
      lh.hidden = !lhTxt;
    }
    var wait = root.querySelector('[data-sig-wait]');
    var fertigungForce = wait && wait.dataset.fertigungForce === '1';
    if(wait){
      var knapp = false, lager = false;
      if(fertigungForce && v.available){
        wait.innerHTML = wait.dataset.fertigung || T.fertigungFallback;
      } else if(typeof v.liefer === 'string'){
        // aufbau_kompakt: eine Angabe je Variante aus snippets/hpl-lieferangabe (Termin oder Wochenspanne)
        wait.innerHTML = v.liefer;
        knapp = v.available && v.qty > 0 && v.qty <= 3;
        lager = v.available && v.qty > 3;
      } else if(v.qty > 0){
        var vh = (wait.dataset.versand || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        wait.innerHTML = ((v.qty === 1)
          ? T.lagerEins
          : (v.qty <= 3 ? T.lagerWenige
                        : T.lager)) + (vh ? ' ' + vh : '');
        knapp = v.qty <= 3;
        lager = v.qty > 3;
      } else if(!v.available){
        wait.innerHTML = T.nvPunkt;
      } else {
        wait.innerHTML = wait.dataset.fertigung || T.fertigungFallback;
      }
      if(wait.parentElement){
        wait.parentElement.classList.toggle('sig-wait--knapp', knapp);
        wait.parentElement.classList.toggle('sig-wait--lager', lager);
      }
    }
    // Zahlweise/Downpay nur bei Vorbestellung (nicht auf Lager); sonst Raten-Hinweis
    var pm = root.querySelector('#sigPaymode');
    var note = root.querySelector('#sigPayNote');
    if(pm){
      if((!fertigungForce && v.qty > 0) || !v.available){
        pm.style.display = 'none';
        var full = root.querySelector('input[name="sig-pm"][value="full"]');
        if(full) full.checked = true;
        pmSync();
        if(note) note.style.display = v.available ? '' : 'none';
      } else {
        pm.style.display = '';
        if(note) note.style.display = 'none';
      }
    }
  }
  var spInput = root.querySelector('#sigSP');
  var pmRadios = root.querySelectorAll('input[name="sig-pm"]');
  var pmHint = root.querySelector('#sigPmHint');
  function pmSync(){ pmRadios.forEach(function(x){ var l = x.closest('.sig-pm'); if(l) l.classList.toggle('is-on', x.checked); if(x.checked){ if(spInput) spInput.disabled = (x.value !== 'deposit'); if(pmHint) pmHint.hidden = (x.value !== 'deposit'); } }); }
  pmRadios.forEach(function(r){ r.addEventListener('change', pmSync); });
  pmSync();

  // Case-Zuwahl (Master): Checkbox legt das Case per AJAX mit in den Warenkorb.
  // Fallback bei Fehler: Häkchen raus + normaler Formular-Weg (Warenkorb-Wache fängt das fehlende Case).
  var addonCb = root.querySelector('[data-sig-addon]');
  var sigForm = document.getElementById('sig-form');
  if(addonCb && sigForm){
    sigForm.addEventListener('submit', function(e){
      if(!addonCb.checked) return;
      e.preventDefault();
      var items = [];
      var mainItem = { id: parseInt(idInput.value, 10), quantity: 1 };
      if(spInput && !spInput.disabled && spInput.value){
        mainItem.properties = mainItem.properties || {};
        mainItem.properties['Zahlweise'] = spInput.value;
      }
      items.push(mainItem);
      items.push({ id: parseInt(addonCb.getAttribute('data-sig-addon'), 10), quantity: 1 });
      if(atc) atc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){
        if(!r.ok) throw new Error('cart add failed');
        window.location.href = '/cart';
      }).catch(function(){
        if(atc) atc.disabled = false;
        addonCb.checked = false;
        sigForm.submit();
      });
    });
  }

  root.querySelectorAll('.sig-chip[data-opt]').forEach(function(c){
    c.addEventListener('click', function(){
      root.querySelectorAll('.sig-chip[data-opt="'+c.dataset.opt+'"]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      c.setAttribute('aria-pressed','true');
      selected[c.dataset.opt] = c.dataset.value;
      update();
      if(c.dataset.hz){ var tab = root.querySelector('.sig-ptab[data-hz="'+c.dataset.hz+'"]'); if(tab) tab.click(); }
    });
  });

  // aufbau_kompakt: Start der Klangprobe einmal je Video als hpl_cta_click „produkt:klang_play“ melden.
  // Der Wistia-Player startet im eigenen Element, ein Klick-Marker greift dort nicht.
  var kpSpalte = root.querySelector('#sig-klangprobe');
  if(kpSpalte){
    var gemeldet = {};
    kpSpalte.querySelectorAll('wistia-player').forEach(function(pl){
      pl.addEventListener('play', function(){
        var id = pl.getAttribute('media-id') || '';
        if(gemeldet[id]) return;
        gemeldet[id] = true;
        if(typeof window.hplCtaMelden === 'function') window.hplCtaMelden('produkt:klang_play', id);
      });
    });
  }

  // Klangprobe-Video: 440/432 sanft ein-/ausblenden (beide Player bleiben – kein Neu-Aufbau, kein Ruckeln)
  var kpBox = root.querySelector('#sigKp');
  if(kpBox){
    var kpPanes = kpBox.querySelectorAll('.sig-kp-pane');
    if(kpPanes.length > 1){
      root.querySelectorAll('.sig-kp-tab').forEach(function(t){
        t.addEventListener('click', function(){
          root.querySelectorAll('.sig-kp-tab').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
          t.setAttribute('aria-pressed','true');
          kpPanes.forEach(function(p){
            var on = p.getAttribute('data-hz') === t.dataset.hz;
            p.hidden = !on;
            if(!on){ var pl = p.querySelector('wistia-player'); try{ if(pl && typeof pl.pause === 'function') pl.pause(); }catch(e){} }
          });
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-sig-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  var boxes = document.querySelectorAll('[data-pc]');
  if(!boxes.length) return;
  var form = document.getElementById('sig-form');
  var vid = document.getElementById('sigVid');
  function euro(c){
    c = parseInt(c, 10);
    if(isNaN(c)) return '';
    var e = Math.floor(c / 100), r = c % 100, t = String(e);
    if(e >= 1000) t = String(Math.floor(e / 1000)) + '.' + ('00' + (e % 1000)).slice(-3);
    if(r > 0) t += ',' + ('0' + r).slice(-2);
    return t + ' €';
  }
  function current(){
    var data = window.HPL_SIG;
    if(!data || !data.variants || !vid) return null;
    var id = String(vid.value);
    for(var i = 0; i < data.variants.length; i++){ if(String(data.variants[i].id) === id) return data.variants[i]; }
    return null;
  }
  function sync(){
    var v = current();
    if(!v) return;
    var cents = (window.HPL_PC_CENTS || {})[String(v.id)];
    var vor = v.tracked && v.policy === 'continue' && v.qty <= 0;
    for(var i = 0; i < boxes.length; i++){
      var box = boxes[i];
      var p = box.querySelector('[data-pc-preis]');
      if(p && cents != null) p.textContent = window.HPL_PC_DE_EUR ? euro(cents) : ((window.HPL_PC_FMT || {})[String(v.id)] || euro(cents));
      var va = box.querySelector('[data-pc-variante]');
      if(va && v.options) va.textContent = v.options.join(' · ');
      var btn = box.querySelector('[data-pc-btn]');
      var lbl = box.querySelector('[data-pc-btn-label]');
      var st = box.querySelector('[data-pc-status]');
      if(btn) btn.disabled = !v.available;
      if(btn && lbl) lbl.textContent = !v.available ? window.HPL_PC_NV.ohne : (v.qty > 0 ? btn.dataset.labelLager : (vor ? btn.dataset.labelVor : btn.dataset.labelFert));
      if(st && st.dataset.zentral && typeof v.lieferKurz === 'string') st.textContent = v.lieferKurz;
      else if(st) st.textContent = !v.available ? window.HPL_PC_NV.punkt : (v.qty > 0 ? st.dataset.stLager : (vor ? st.dataset.stVor : st.dataset.stFert));
    }
  }
  if(!form){
    // Ohne Kaufformular (andere Vorlage): Knopf springt zum Kaufbereich statt abzuschicken.
    for(var j = 0; j < boxes.length; j++){
      (function(btn){
        if(!btn) return;
        btn.type = 'button';
        btn.addEventListener('click', function(){
          var ziel = document.getElementById('sig-kaufbereich');
          if(ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      })(boxes[j].querySelector('[data-pc-btn]'));
    }
  }
  // Variantenwechsel: die Kaufbox aktualisiert #sigVid in ihrem Klick-Handler; danach nachziehen.
  document.addEventListener('click', function(e){
    var t = e.target;
    if(t && t.closest && t.closest('.sig-chip[data-opt]')) window.setTimeout(sync, 0);
  });
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-sig-skala"] && !Shopify.designMode) return;
  try {
    
(function(){
  var box = document.getElementById('sigTones');
  if(!box) return;
  var SEMI = { C:0, D:2, E:4, F:5, G:7, A:9, B:11, H:11 };
  function pitch(n){
    if(!n) return 9999;
    var m = String(n).trim().match(/^([A-Ha-h])([#b♭♯]?)(\d)$/);
    if(!m) return 9999;
    var s = SEMI[m[1].toUpperCase()];
    if(s == null) return 9999;
    if(m[2] === '#' || m[2] === '♯') s += 1;
    else if(m[2] === 'b' || m[2] === '♭') s -= 1;
    return parseInt(m[3], 10) * 12 + s;
  }
  var spans = Array.prototype.slice.call(box.querySelectorAll('[data-note]'));
  spans.sort(function(a, b){ return pitch(a.getAttribute('data-note')) - pitch(b.getAttribute('data-note')); });
  spans.forEach(function(sp){ box.appendChild(sp); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-sig-sticky"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar = document.getElementById('sigSticky');
  var target = document.querySelector('[data-sig-buy]');
  if(!bar || !target || !('IntersectionObserver' in window)) return;
  var btn = bar.querySelector('.sig-sticky-btn');
  function setOn(on){ bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); if(btn){ btn.tabIndex = on ? 0 : -1; } }
  if(btn){ btn.addEventListener('click', function(){
    var dest = document.getElementById('sig-kaufbereich') || target;
    function targetNow(){ var y = dest.getBoundingClientRect().top + window.pageYOffset - 90; return y < 0 ? 0 : y; }
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(rm){ window.scrollTo(0, targetNow()); return; }
    // eigener Smooth-Scroll (nativer behavior:'smooth' wirkt hier nicht zuverlässig); Ziel pro Frame neu
    var startY = window.pageYOffset, dur = 500, t0 = null, done = false;
    function step(ts){ if(done){ return; } if(t0 === null){ t0 = ts; } var p = Math.min((ts - t0) / dur, 1); var e = p < 0.5 ? 2*p*p : -1 + (4 - 2*p)*p; window.scrollTo(0, startY + (targetNow() - startY) * e); if(p < 1){ requestAnimationFrame(step); } else { done = true; } }
    requestAnimationFrame(step);
    // Sicherheitsnetz: läuft rAF nicht (z. B. pausiert), garantiert ans Ziel springen
    setTimeout(function(){ if(!done){ done = true; window.scrollTo(0, targetNow()); } }, dur + 80);
  }); }
  // Lieferangabe der gewaehlten Variante nachziehen (nur mit lieferstatus_an, Daten aus window.HPL_SIG)
  var st = bar.querySelector('[data-sticky-status]');
  if(st){
    var syncStatus = function(){
      var data = window.HPL_SIG, vid = document.getElementById('sigVid');
      if(!data || !data.variants || !vid) return;
      for(var i = 0; i < data.variants.length; i++){
        if(String(data.variants[i].id) === String(vid.value) && typeof data.variants[i].lieferKurz === 'string'){ st.textContent = data.variants[i].lieferKurz; return; }
      }
    };
    document.addEventListener('click', function(e){ if(e.target && e.target.closest && e.target.closest('.sig-chip[data-opt]')) window.setTimeout(syncStatus, 0); });
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ setOn(!e.isIntersecting && e.boundingClientRect.top < 0); });
  }, { threshold: 0 });
  io.observe(target);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-stadtseite"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-stx-wistia]');
  if (!btn) return;
  var frame = document.createElement('iframe');
  frame.src = 'https://fast.wistia.net/embed/iframe/' + encodeURIComponent(btn.getAttribute('data-stx-wistia')) + '?autoPlay=true&videoFoam=true';
  frame.allow = 'autoplay; fullscreen';
  frame.title = 'Klangvideo';
  btn.replaceWith(frame);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-starter-launch"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.hpl-launch');
  if (!root) return;

  // Tracking darf die Seite nie aufhalten - alles gekapselt, dataLayer defensiv.
  function push(event, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event };
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      }
      window.dataLayer.push(payload);
    } catch (e) { /* still */ }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-lb-cta]'), function (a) {
    a.addEventListener('click', function () {
      push('starter_launch_click', {
        product_handle: a.getAttribute('data-handle') || '',
        position: parseInt(a.getAttribute('data-pos'), 10) || 0
      });
    });
  });

  var beratung = root.querySelector('[data-lb-beratung]');
  if (beratung) {
    beratung.addEventListener('click', function () {
      push('consultation_path_click', { source: 'starter_launch' });
    });
  }

  // Sichtbarkeit: einmal je Sitzung, ab 50 % im Viewport.
  // sessionStorage wirft im privaten Modus mancher Browser - deshalb gekapselt.
  var KEY = 'hpl_launch_view';
  function gesehen() {
    try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function merken() {
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) { /* still */ }
  }
  if (!gesehen() && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        if (gesehen()) return;
        merken();
        push('starter_launch_view', {});
      });
    }, { threshold: 0.5 });
    io.observe(root);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hpl-termin-detail"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var a = e.target.closest('.trm-cta[data-trm]');
  if (!a) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'workshop_booking_click',
    termin_id: a.dataset.handle,
    ort: a.dataset.ort,
    partner: a.dataset.partner,
    preis: a.dataset.preis,
    status: a.dataset.status,
    ziel_domain: a.hostname
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
/* Umbau 3c: „Dazu passt“ auf der Warenkorb-Seite: Artikel per AJAX dazulegen (Merkmal _quelle dazu-passt-warenkorb), Seite neu laden.
   Die Handpan-Position mit ihrem Merkmal „Oberfläche gelesen“ bleibt unberührt, der Kassen-Knopf ist nach dem Neuladen wieder bedienbar. */
document.addEventListener('click', function (e) {
  var add = e.target.closest('[data-hpl-dazu-seite]');
  if (!add) return;
  e.preventDefault();
  add.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-hpl-dazu-seite'), 10), quantity: 1, properties: { _quelle: 'dazu-passt-warenkorb' } }] })
  }).then(function (r) {
    if (!r.ok) { add.disabled = false; return; }
    window.location.reload();
  }).catch(function () { add.disabled = false; });
});

  } catch(e) { console.error(e); }
})();
})();
